import { gql, useMutation } from '@apollo/client'

interface Result {
  updateStore: boolean
}

interface Form {
  storeId: string
  enabled: boolean
  autoQuote: boolean
}

const mutation = gql`
  mutation SupplierUpdateStore($storeId: ID!, $enabled: Boolean!, $autoQuote: Boolean!) {
    supplierUpdateStore(storeId: $storeId, enabled: $enabled, autoQuote: $autoQuote)
  }
`

const useUpdateStore = () => {
  const [mutate] = useMutation<Result, Form>(mutation)

  return (variables: Form) => mutate({ variables })
}

export default useUpdateStore
